<template>
  <div class="square-terminal-payment-button">
    <div
      class="wrapper square-payment-button"
      :disabled="disabled"
      :class="{ 'terminal-disconnected': terminalDisconnected, 'processing': processing }"
      @click="processPayment"
    >
      <div
        class="square-terminal-label"
        :class="{ 'enabled': terminalConnected }"
      >
        <div class="icon">
          <font-awesome-icon
            icon="credit-card"
            size="4x"
          />
        </div>
        <div class="inner">
          <div v-if="terminalConnected">
            <slot>
              Square terminal
            </slot>
          </div>
          <div v-if="terminalDisconnected">
            <slot name="disconnected-label">
              Square terminal (disconnected)
            </slot>
          </div>
          <div
            v-if="enableUserCardStorage && !isAnonymous"
            class="store-terminal-card-option"
            @click.stop="toggleStoredCard"
          >
            <b-form-checkbox
              :checked="value"
              :disabled="processing || !isAnonymous"
              class="store-user-credit-card payment-option"
              @change="toggleStoredCard"
            >
              <slot name="store-credit-card-details">
                Store credit card details for future use
              </slot>
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SquarePaymentsMixin from '../mixins/square-payments'

export default {
  name: 'square-terminal-payment-button',
  mixins: [
    SquarePaymentsMixin
  ],
  props: {
    value: {
      type: Boolean,
      required: false,
      default: true
    },
    enableUserCardStorage: {
      type: Boolean,
      required: false,
      default: true
    },
    userid: {
      type: String,
      required: false,
      default: '0'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    terminalDisconnected: function() {
      return !this.$store.getters['square/terminalConnected']
    },
    terminalConnected: function() {
      return this.$store.getters['square/terminalConnected']
    }
  },
  methods: {
    processPayment: function() {
      if (!this.disabled && !this.processing && this.terminalConnected) {
        this.$emit('click')
      }
    },
    toggleStoredCard: function() {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>

  .square-terminal-payment-button {
    border: 1px solid #eee;
    cursor: pointer;

    .wrapper .square-terminal-label {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 0.75rem 0.9rem;

      div:nth-child(1) {
        margin-right: 0.8rem;
      }

      .store-terminal-card-option {
        margin-left: 1.2em;
        cursor: pointer;

        .store-user-credit-card {
          font-weight: 100;
          pointer-events: auto;
          cursor: pointer;
        }
      }
    }
  }

</style>
